import { render } from "./IngredientForm.vue?vue&type=template&id=04a7eb98"
import script from "./IngredientForm.vue?vue&type=script&lang=js"
export * from "./IngredientForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stick\\projects\\recipe-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__